import { put, takeLatest } from 'redux-saga/effects';
import { postDiploma, putDiploma, getDiploma, deleteDiploma } from './api';
import { PUT_DIPLOMA, POST_DIPLOMA, GET_DIPLOMA, DELETE_DIPLOMA } from './constants';
import { putDiplomaSuccess, postDiplomaSuccess, getDiplomaSuccess, deleteDiplomaSuccess } from './actions';

/**
 *
 * @param obj
 * @returns {IterableIterator<PutEffect<{result: *, type: string}>>}
 */
function* diplomaPut( obj ) {
    const serverResponse = yield  putDiploma( obj.data, obj.id );
    if ( serverResponse ) {
        yield put( putDiplomaSuccess( serverResponse ) );
    }
}

/**
 *
 * @param obj
 * @returns {IterableIterator<PutEffect<{result: *, type: string}>>}
 */
function* diplomaPost( obj ) {
    const serverResponse = yield postDiploma( obj.data );
    if ( serverResponse ) {
        yield put( postDiplomaSuccess( serverResponse ) );
    }
}

/**
 *
 * @param obj
 * @returns {IterableIterator<PutEffect<{result: *, type: string}>>}
 */
function* diplomaGet( obj ) {
    const serverResponse = yield getDiploma( obj.id );
    if ( serverResponse ) {
        yield put( getDiplomaSuccess( serverResponse ) );
    }
}

/**
 *
 * @param obj
 * @returns {IterableIterator<PutEffect<{result: *, type: string}>>}
 */
function* diplomaDelete( obj ) {
    const serverResponse = yield deleteDiploma( obj.id );
    if ( serverResponse ) {
        yield put( deleteDiplomaSuccess( serverResponse ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchEditorDiploma() {
    yield takeLatest( PUT_DIPLOMA, diplomaPut );
    yield takeLatest( POST_DIPLOMA, diplomaPost );
    yield takeLatest( GET_DIPLOMA, diplomaGet );
    yield takeLatest( DELETE_DIPLOMA, diplomaDelete );
}

export default watchEditorDiploma;
